import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { IBrandOrder } from "@faire/web-api--source/indigofair/data/IBrandOrder";
import React from "react";

import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";

import { ViewOrderDetailsCTA, ViewOrdersCTA } from "./ctas";
import { UpdateTrackingInfoIA } from "./instantAnswersComponents/orders/UpdateTrackingInfoIA";

export const updateTrackingInfo: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
  additionalRequiredData: [ShippingContextDataFn],
});

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => UPDATE_TRACKING_INFO_TITLE(context, strictLocalize),
    getDescription: () => UPDATE_TRACKING_INFO_DESCRIPTION(context),
  };
};

const UPDATE_TRACKING_INFO_TITLE = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => {
  const shippingContext = context.shippingContext;
  if (!shippingContext) {
    return "";
  }
  const orderState = shippingContext.state;
  if (orderState === IBrandOrder.State.PROCESSING) {
    return strictLocalize({
      defaultMessage: "Updating shipping information",
      description: {
        text: "Title for the instant answer about updating shipping information",
      },
    });
  } else {
    return strictLocalize({
      defaultMessage: "Updating tracking for a shipped order",
      description: {
        text: "Title for the instant answer about tracking information",
      },
    });
  }
};

const getPrimaryCTA: CtaBuilderFn = (context, strictLocalize) => {
  const brandOrderToken = context.brandOrder?.brand_order?.token;
  if (brandOrderToken) {
    return ViewOrderDetailsCTA(brandOrderToken, strictLocalize);
  }
  return ViewOrdersCTA(strictLocalize);
};

const UPDATE_TRACKING_INFO_DESCRIPTION = (context: InstantAnswerContext) => {
  if (!context.shippingContext) {
    return [];
  }
  return (
    <UpdateTrackingInfoIA
      shippingContext={context.shippingContext}
      isSwf={context.brandOrder?.is_ship_with_faire}
    />
  );
};
